/* ==========================================================================
 * aef-md-i18n.js — bilingual (EN/VI) for the REDESIGN homepage sections.
 * Self-contained: does NOT touch the theme's own i18n. Localizes elements with
 * [data-mdi18n] (textContent) and [data-mdi18n-html] (innerHTML) based on the
 * shared `ae_lang` (localStorage / <html lang>). Re-applies when the language
 * changes (storage event + <html lang> mutation) so it works whether the theme
 * switches language by reload or live.
 * ========================================================================== */
(function(){
  'use strict';
  if (window.__aefMdI18n) return; window.__aefMdI18n = true;

  var DICT = {
    en: {
      'md.eyebrow':'🚚 Authentic Asian groceries — shipped across the US',
      'md.h1':'Authentic Asian groceries,<br><em>delivered to your door.</em>',
      'md.sub':'Vietnamese · Korean · Chinese · Japanese · Thai — hard-to-find brands at your door.',
      'md.hero_cta':'Shop mooncakes →',
      /* nút chính sau ngày hết mùa của video 1 (sections/aef-hero-video.liquid, hv_het_mua) */
      'md.hero_cta_best':'Shop best sellers →',
      'md.hv_v2_line':'🔥 See what our customers buy most →',
      'md.t_weekly':'Weekly deals','md.t_upto':'Up to 50% off','md.t_shopdeals':'Shop deals →',
      'md.t_freeship':'Free shipping','md.t_freeship_sub':'on orders {n}+',
      'md.freeship_at':'Free shipping on orders {n}+','md.freeship_usps':'Shipping calculated at checkout','md.freeship_khong_giao':"We don't ship to your area yet",
      'md.cut_dfw':'SAME-DAY delivery in DFW','md.cut_natl':'· authentic Asian groceries shipped across the US',
      'md.cut_closed':'Same-day cutoff has passed — order now and we ship first thing tomorrow',
      'md.cut_open_pre':'⏰ Order within {n} for',
      'md.hv_sound_on':'Turn sound on','md.hv_sound_off':'Turn sound off',
      /* nút ▶ dự phòng — hiện khi trình duyệt chặn tự phát (assets/aef-hero-video.js) */
      'md.hv_play':'Play video',
      /* nhãn đọc màn hình của video khi ô mô tả còn là chữ mặc định (sections/aef-hero-video.liquid, hv_alt_key) */
      'md.hv_alt_cua_hang':'A&E Foodstore — store introduction video',
      'md.hero_cta2':'This week’s deals',
      'md.stat_ship':'🚚 Nationwide','md.stat_ship_sub':'shipped across the US',
      'md.stat_orders':'📦 Orders delivered','md.stat_products':'🥢 Authentic products',
      'md.stat_reviews':'from {n} reviews',
      /* aria-label của gốc <section> aef-stat-bar — vòng 53 i18n#7 */
      'md.stat_aria':'Store highlights',
      'md.t_loved':'🏆 Loved by shoppers','md.t_best':'Bestsellers',
      'md.t_fresh':'✨ Fresh this week','md.t_new':'New arrivals',
      'md.h_hotdeals':'🔥 Hot Deals','md.h_best':'🏆 Bestsellers this week','md.h_cuisine':'🌏 Shop by cuisine',
      'md.viewall':'View all →','md.allcat':'All categories →',
      /* Phụ đề 6 ô ẩm thực (20/8/2026, vòng 24). TÊN ô thì dùng khoá `cuisine.*`
         của từ điển chính — cùng khoá mà ngăn ☰ đang dùng, để hai chỗ không bao
         giờ trôi lệch nhau. Chỉ PHỤ ĐỀ mới nằm ở đây vì nó riêng của khối này. */
      'md.cuis_vn':'Phở · Nước mắm','md.cuis_kr':'Kimchi · Gochujang',
      'md.cuis_cn':'Sauces · Hotpot','md.cuis_jp':'Ramen · Wasabi',
      'md.cuis_th':'Curry · Coconut','md.cuis_ph':'Adobo · Snacks',
      'md.fsb_h':'Free shipping on orders {n}+ 🚚','md.fsb_p':'Add your favorites — hit the threshold and delivery is on us.','md.fsb_b':'Keep shopping →',
      'md.trust1_b':'Shipped across the US','md.trust1_s':'Same-day within 20 mi of Arlington TX',
      'md.trust2_b':'Vietnamese-owned','md.trust2_s':'Started in our garage, now in Arlington, TX',
      'md.trust3_b':'7-day returns','md.trust3_s':'Unopened pantry items OK · full refund if damaged',
      'md.trust4_b':'Secure checkout','md.trust4_s':'Shop Pay · Visa · PayPal',
      'md.addcart':'＋ Add to cart','md.soldout':'Sold out',
      'md.adding':'Adding…','md.retry':'Try again',
      'md.sold':'sold','md.only_left':'Only {n} left','md.save':'Save','md.min_order':'Min order:'
    },
    vi: {
      'md.eyebrow':'🚚 Đồ Á chính hãng — giao khắp nước Mỹ',
      'md.h1':'Đồ Á chính hãng,<br><em>giao tận cửa nhà bạn.</em>',
      'md.sub':'Việt · Hàn · Trung · Nhật · Thái — thương hiệu khó tìm, giao tận nhà.',
      'md.hero_cta':'Mua bánh trung thu →',
      'md.hero_cta_best':'Mua hàng bán chạy →',
      'md.hv_v2_line':'🔥 Xem những món khách mua nhiều nhất →',
      'md.t_weekly':'Ưu đãi tuần','md.t_upto':'Giảm đến 50%','md.t_shopdeals':'Xem ưu đãi →',
      'md.t_freeship':'Miễn phí giao','md.t_freeship_sub':'cho đơn từ {n}',
      'md.freeship_at':'Miễn phí giao cho đơn từ {n}','md.freeship_usps':'Phí giao tính ở bước thanh toán','md.freeship_khong_giao':'Tiệm chưa giao tới khu vực của bạn',
      'md.cut_dfw':'GIAO TRONG NGÀY tại DFW','md.cut_natl':'· đồ Á chính hãng, giao khắp nước Mỹ',
      'md.cut_closed':'Đã qua giờ chốt giao trong ngày — đặt ngay, sáng mai shop gửi hàng liền',
      'md.cut_open_pre':'⏰ Đặt trong {n} nữa để được',
      'md.hv_sound_on':'Bật tiếng','md.hv_sound_off':'Tắt tiếng',
      'md.hv_play':'Xem video',
      'md.hv_alt_cua_hang':'A&E Foodstore — video giới thiệu cửa hàng',
      'md.hero_cta2':'Ưu đãi tuần này',
      'md.stat_ship':'🚚 Toàn quốc','md.stat_ship_sub':'giao khắp nước Mỹ',
      'md.stat_orders':'📦 Đơn đã giao','md.stat_products':'🥢 Sản phẩm chính hãng',
      'md.stat_reviews':'từ {n} đánh giá',
      'md.stat_aria':'Điểm nổi bật của tiệm',
      'md.t_loved':'🏆 Khách yêu thích','md.t_best':'Bán chạy',
      'md.t_fresh':'✨ Mới tuần này','md.t_new':'Hàng mới về',
      'md.h_hotdeals':'🔥 Ưu đãi HOT','md.h_best':'🏆 Bán chạy tuần này','md.h_cuisine':'🌏 Mua theo ẩm thực',
      'md.viewall':'Xem tất cả →','md.allcat':'Tất cả danh mục →',
      'md.cuis_vn':'Phở · Nước mắm','md.cuis_kr':'Kimchi · Tương ớt',
      'md.cuis_cn':'Nước sốt · Lẩu','md.cuis_jp':'Mì ramen · Mù tạt',
      'md.cuis_th':'Cà ri · Nước cốt dừa','md.cuis_ph':'Adobo · Đồ ăn vặt',
      'md.fsb_h':'Miễn phí giao cho đơn từ {n} 🚚','md.fsb_p':'Thêm món yêu thích — đạt ngưỡng là được giao miễn phí.','md.fsb_b':'Tiếp tục mua →',
      'md.trust1_b':'Giao khắp nước Mỹ','md.trust1_s':'Giao trong ngày trong 20 dặm quanh kho Arlington TX',
      'md.trust2_b':'Tiệm của người Việt','md.trust2_s':'Bắt đầu từ garage nhà mình, nay ở Arlington, TX',
      'md.trust3_b':'Đổi trả 7 ngày','md.trust3_s':'Hàng khô chưa mở trả được · hư hỏng hoàn đủ tiền',
      'md.trust4_b':'Thanh toán an toàn','md.trust4_s':'Shop Pay · Visa · PayPal',
      'md.addcart':'＋ Thêm vào giỏ','md.soldout':'Hết hàng',
      'md.adding':'Đang thêm…','md.retry':'Thử lại',
      'md.sold':'đã bán','md.only_left':'Chỉ còn {n}','md.save':'Tiết kiệm','md.min_order':'Đặt tối thiểu:'
    }
  };

  function lang(){
    var l;
    try { l = localStorage.getItem('ae_lang'); } catch(e){}
    if (!l) l = (document.documentElement.getAttribute('lang') || 'en').slice(0,2).toLowerCase();
    return DICT[l] ? l : 'en';
  }
  function apply(){
    var d = DICT[lang()] || DICT.en;
    document.querySelectorAll('[data-mdi18n]').forEach(function(el){
      var v = d[el.getAttribute('data-mdi18n')]; if (v != null) el.textContent = v;
    });
    document.querySelectorAll('[data-mdi18n-html]').forEach(function(el){
      var v = d[el.getAttribute('data-mdi18n-html')]; if (v != null) el.innerHTML = v;
    });
    // Câu có chèn số — không tách được thành "nhãn + số" vì trật tự từ mỗi thứ
    // tiếng một khác ("Only 3 left" ↔ "Chỉ còn 3"). Nên giữ nguyên cả câu trong
    // dict với chỗ trống {n}, số lấy từ data-mdi18n-n.
    document.querySelectorAll('[data-mdi18n-tpl]').forEach(function(el){
      var v = d[el.getAttribute('data-mdi18n-tpl')];
      if (v == null) return;
      el.textContent = v.split('{n}').join(el.getAttribute('data-mdi18n-n') || '');
    });
    // Nút chỉ có icon (loa bật/tắt tiếng ở hero video) không có chữ để dịch — cái
    // duy nhất người dùng trình đọc màn hình nghe được là aria-label. Không dịch
    // nó thì với khách VI, nút đó vĩnh viễn đọc ra tiếng Anh.
    document.querySelectorAll('[data-mdi18n-aria-label]').forEach(function(el){
      var v = d[el.getAttribute('data-mdi18n-aria-label')];
      if (v != null) el.setAttribute('aria-label', v);
    });
  }

  function init(){
    apply();
    // live language switches
    window.addEventListener('storage', function(e){ if (e.key === 'ae_lang') apply(); });
    try {
      new MutationObserver(apply).observe(document.documentElement, { attributes:true, attributeFilter:['lang'] });
    } catch(e){}
    // safety re-apply shortly after load (in case theme sets lang late)
    setTimeout(apply, 400); setTimeout(apply, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.aefMdI18nApply = apply;
  // Lookup for strings JS builds at runtime (button states, "Only N left"), which
  // have no [data-mdi18n] element for apply() to walk.
  window.aefMdI18nText = function (key, vars) {
    var v = (DICT[lang()] || DICT.en)[key];
    if (v == null) return null;
    if (vars) Object.keys(vars).forEach(function (k) { v = v.split('{' + k + '}').join(vars[k]); });
    return v;
  };
})();
